module.exports = __webpack_public_path__ + "img/sholom-benzev-wins-carr-challenge-snap-quiz-new.ee076c82.jpg";